(function () {
    'use strict';

    angular
        .module('app.sso')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'sso',
                config: {
                    url: '/sso',
                    abstract: true,
                    ncyBreadcrumb: {
                        label: 'SSO'
                    },
                    template: '<ui-view/>'
                }
            },
            {
                state: 'sso.logout',
                config: {
                    url: '/logout?returnURL&userID',
                    templateUrl: 'app/sso/logout/sso.logout.html',
                    controller: 'LogoutController',
                    controllerAs: 'vm',
                    title: 'SSO Log Out',
                    ncyBreadcrumb: {
                        label: 'Log Out'
                    },
                    settings: {
                        isVisible: false,
                        nav: 1,
                        content: ''
                    }
                }
            }
        ];
    }
})();
